<div class="portal--header">
  <h1 class="heading">Account settings</h1>
</div>
<div class="portal--main">
  <div class="module-wrapper">
    <div class="module drop-shadow bottom">
      <form class="std-form" [formGroup]="form" (submit)="submit(form)" autocomplete="off" novalidate>
        <h2>User details</h2>
        <div class="row">
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="form-group" [ngClass]="{'danger':(form.controls['firstName'].invalid && submitted)}">
              <label for="f-name">First name*</label>
              <input type="text" id="f-name" [formControl]="form.controls['firstName']">
              <span *ngIf="form.controls['firstName'].hasError('required') && submitted" class="validation-msg">First name is required</span>
              <span *ngIf="form.controls['firstName'].hasError('maxlength') && submitted" class="validation-msg">First name must be 200 characters or less</span>

            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="form-group" [ngClass]="{'danger':(form.controls['lastName'].invalid && submitted)}">
              <label for="s-name">Last name*</label>
              <input type="text" id="s-name" [formControl]="form.controls['lastName']">
              <span *ngIf="form.controls['lastName'].hasError('required') && submitted" class="validation-msg">Last name is required</span>
              <span *ngIf="form.controls['lastName'].hasError('maxlength') && submitted" class="validation-msg">Last name must be 200 characters or less</span>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="form-group" [ngClass]="{'danger':(form.controls['jobTitle'].invalid && submitted)}">
              <label for="job">Job title*</label>
              <input type="text" id="job" [formControl]="form.controls['jobTitle']">
              <span *ngIf="form.controls['jobTitle'].hasError('required') && submitted" class="validation-msg">Job title is required</span>
              <span *ngIf="form.controls['jobTitle'].hasError('maxlength') && submitted" class="validation-msg">Job title must be 200 characters or less</span>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div class="form-group" [ngClass]="{'danger':(form.controls['phoneNumber'].invalid && submitted)}">
              <label for="phone-number">Phone Number*</label>
              <input type="text" id="phone-number" [formControl]="form.controls['phoneNumber']">
              <span *ngIf="form.controls['phoneNumber'].hasError('required') && submitted" class="validation-msg">Phone number is required</span>
              <span *ngIf="form.controls['phoneNumber'].hasError('maxlength') && submitted" class="validation-msg">Phone number must be 200 characters or less</span>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div [formGroup]="emails" class="form-group" [ngClass]="{'danger':(emails.controls['email'].invalid && submitted)}">
              <label for="email">Email</label>
              <input type="email" id="email" [formControl]="emails.controls['email']" disabled="true" readonly>
              <span *ngIf="emails.controls['email'].hasError('required') && submitted" class="validation-msg">Email is required</span>
              <span *ngIf="emails.controls['email'].hasError('email') && submitted" class="validation-msg">Email address is invalid</span>
              <span *ngIf="emails.controls['email'].hasError('maxlength') && submitted" class="validation-msg">Email must be 200 characters or less</span>
            </div>
          </div>
          <!-- <div class="col-md-3 col-sm-6 col-xs-12">
            <div [formGroup]="emails" class="form-group" [ngClass]="{'danger':(emails.controls['confirmEmail'].invalid && submitted)}">
              <label for="confirm-email">Confirm email*</label>
              <input type="email" id="confirm-email" [formControl]="emails.controls['confirmEmail']">
              <span *ngIf="emails.controls['confirmEmail'].hasError('email') && submitted" class="validation-msg">Email address is invalid</span>
              <span *ngIf="emails.controls['confirmEmail'].hasError('maxlength') && submitted" class="validation-msg">Email must be 200 characters or less</span>
              <span *ngIf="emails.controls['confirmEmail'].hasError('validateEmailConfirmation') && submitted" class="validation-msg">Email addresses don't match</span>
            </div>
          </div> -->
        </div>
        <hr>

        <h2>Change password</h2>
        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-12">
              <div [formGroup]="passwords" class="form-group" [ngClass]="{'danger':(passwords.controls['oldPassword'].invalid && submitted)}">
                  <label for="oldPassword">Old password*</label>
                  <input id="oldPassword" [ngClass]="{'check':passwords.controls['password'].valid}" class="form-control" [formControl]="passwords.controls['oldPassword']" type="password" (change)="onPasswordChange()">
                  <span *ngIf="passwords.controls['oldPassword'].hasError('oldPasswordRequired') && submitted" class="validation-msg">Old password is required</span>
                  <span *ngIf="passwords.controls['oldPassword'].hasError('maxlength') && submitted" class="validation-msg">Password has exceded the allowed length</span>
                  <span *ngIf="passwords.controls['oldPassword'] === passwords.controls['password'] && submitted" class="validation-msg">New password cannot be the same as old password</span>
              </div>
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
              <div [formGroup]="passwords" class="form-group" [ngClass]="{'danger':(passwords.controls['password'].invalid && submitted) || (passwords.controls['password'].hasError('passwordPolicy') && !passwords.controls['password'].hasError('required')) || (passwords.controls['oldPassword'].value === passwords.controls['password'].value && passwords.controls['password'].value != null)}">
                  <label for="password">New password*</label>
                  <show-password [inputFields]="[field1, field2]">
                      <input id="password" #field1 [ngClass]="{'check':passwords.controls['password'].valid}" class="form-control" [formControl]="passwords.controls['password']" type="password" (change)="onPasswordChange()">
                  </show-password>
                  <span class="validation-msg" *ngIf="passwords.controls['oldPassword'].value === passwords.controls['password'].value && passwords.controls['password'].value != null">new password cannot be the same as old password</span>
                  <span *ngIf="passwords.controls['password'].hasError('passwordPolicy'); else elseBlock" class="validation-msg">
                      <span [hidden]="!passwords.controls['password'].hasError('passwordPolicy') || passwords.controls['password'].hasError('passwordRequired')">WEAK</span>
                  </span>
                  <ng-template #elseBlock>
                      <span [hidden]="!passwords.controls['password'].hasError('passwordPolicy') || passwords.controls['password'].hasError('passwordRequired')" class="validation-msg">STRONG</span>
                  </ng-template>
                  <div *ngIf="passwords.controls['password'].hasError('passwordPolicy') && submitted" class="validation-msg">
                      <p>Your password isn't sufficiently complex. Please make sure it meets the following rules:</p>
                      <ul>
                          <li>Contains at least one number</li>
                          <li>Contains at least one uppercase letter</li>
                          <li>Contains at least one lower case letter</li>
                          <li>Contains at least one special character</li>
                          <li>Is at least 12 characters long</li>
                      </ul>
                  </div>
              </div>
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12">
              <div [formGroup]="passwords" class="form-group" [ngClass]="{'danger':(passwords.invalid && submitted)}">
                  <label for="passwordAgain">Confirm new password*</label>
                  <input id="passwordAgain" #field2 [ngClass]="{'check':passwords.controls['password'].valid && passwords.valid}" class="form-control" type="password" [formControl]="passwords.controls['passwordAgain']">
                  <span *ngIf="passwords.hasError('passwordsMatch') && submitted" class="validation-msg">Passwords don't match</span>
              </div>
          </div>
        </div>

        <div class="btn-group center margin">
          <button class="std-btn focus-element" [disabled]="submitting" type="submit"><span class="focus--content" tabindex="-1">{{submitting === true ? "Saving..." : "Save"}}</span></button>
        </div>
      </form>
    </div>
  </div>
</div>
